import {
  emeraldLookup,
  heritageLookup,
  classicLookup,
  sovereignLookup
} from '../data/ercLookupTables';

export const ercDue = (initialAdvance, overpayment, selectedProd) => {
  return overpayment > (initialAdvance * selectedProd);
};

export const calculateErc = (initialAdvance, overpayment, selectedProd, year, productName) => {
  let activeLookup;

  switch (productName) {
    case 'emerald':
      activeLookup = emeraldLookup;
      break;
    case 'heritage':
      activeLookup = heritageLookup;
      break;
    case 'classic':
      activeLookup = classicLookup;
      break;
    case 'sovereign':
      activeLookup = sovereignLookup;
      break;
    default:
      activeLookup = classicLookup;
  }

  return (overpayment - (initialAdvance * selectedProd)) * activeLookup[year];
};

export const createAnnualOverpaymentEquityRemainingGraph = (value, advance, interest, Valinc, annualPayments, selectedProduct, productName) => {
  let dataRemainingBalanceTable = [];
  let equityRemainingGraphDataWithoutPayment = [];
  let equityRemainingGraphDataWithPayment = [];
  let loanBalanceGraphDataWithOutPayment = [];
  let loanBalanceGraphDataWithPayment = [];
  const initialAdvance = advance;
  const initialValue = value;
  let advanceWithPayment = advance;
  const monthlyInterest = (interest / 100 / 12) + 1;
  const monthlyValuationIncrease = (((Valinc / 100)) / 12) + 1;
  let balanceAtStart = advance;
  let balanceAtStartNoPay = advance;
  let valStart = value;

  for (let i = 1; i < 41; i++) {
    if (i === 1) {
      equityRemainingGraphDataWithoutPayment.push({
        date: 0,
        close: value - advance,
      });

      equityRemainingGraphDataWithPayment.push({
        date: 0,
        close: value - advance,
      });

      loanBalanceGraphDataWithOutPayment.push({
        date: 0,
        close: advance,
      });
      loanBalanceGraphDataWithPayment.push({
        date: 0,
        close: advance,
      });

      dataRemainingBalanceTable.push({
        year: 0,
        starBal: advance,
        annualpayment: 0,
        balanceWithPay: initialAdvance,
        ValStart: initialValue,
        ValEnd: initialValue,
        EquityRemPer: (1 - (advance / value)) * 100,
        EquityRem: value - advance,
        EquityRemWithoutPay: value - advance,
        EquityRemPerWithoutPay: (1 - (advance / value)) * 100,
        startBNoPay: balanceAtStartNoPay,
        balanceWithOutPay: advance,
        selectedProduct: selectedProduct,
        initialAdvance: initialAdvance,
        productName: productName,
      });
    }

    for (let j = 1; j <= 12; j++) {
      advance = advance * monthlyInterest;
      advanceWithPayment = advanceWithPayment * monthlyInterest;
      value = value * monthlyValuationIncrease;

      if (j === 12) {
        balanceAtStartNoPay = advance;
        balanceAtStart = advanceWithPayment;
        valStart = value;
      }
    }

    const payments = Array.isArray(annualPayments)
      ? annualPayments.map(payment => ({
        ...payment,
        yearToApplyPayment: payment.yearToApplyPayment
          ? parseFloat(payment.yearToApplyPayment)
          : 0,
        repaymentAmount: payment.repaymentAmount
          ? parseFloat(payment.repaymentAmount.replace(/,/g, ''))
          : 0,
      }))
      : [];

    const annualPaymentForYear = payments.find(payment => {
      return payment.yearToApplyPayment === i;
    });

    if (annualPaymentForYear) {
      // Annual payment exists for this year
      const annualPaymentAmount = parseInt(annualPaymentForYear.repaymentAmount);

      dataRemainingBalanceTable.push({
        year: i,
        starBal: advanceWithPayment - annualPaymentAmount,
        annualpayment: annualPaymentAmount,
        balanceWithPay: advanceWithPayment,
        ValStart: valStart,
        ValEnd: value,
        EquityRemPer: (1 - (advanceWithPayment / value)) * 100,
        EquityRem: value - advanceWithPayment,
        EquityRemWithoutPay: value - advance,
        EquityRemPerWithoutPay: (1 - (advance / value)) * 100,
        startBNoPay: balanceAtStartNoPay,
        balanceWithOutPay: advance,
        selectedProduct: selectedProduct,
        initialAdvance: initialAdvance,
        productName: productName,
      });

      advanceWithPayment = advanceWithPayment - annualPaymentAmount;
    } else {
      dataRemainingBalanceTable.push({
        year: i,
        starBal: balanceAtStart,
        annualpayment: 0,
        balanceWithPay: advanceWithPayment,
        ValStart: valStart,
        ValEnd: value,
        EquityRemPer: (1 - (advanceWithPayment / value)) * 100,
        EquityRem: value - advanceWithPayment,
        EquityRemWithoutPay: value - advance,
        EquityRemPerWithoutPay: (1 - (advance / value)) * 100,
        startBNoPay: balanceAtStartNoPay,
        balanceWithOutPay: advance,
        selectedProduct: selectedProduct,
        initialAdvance: initialAdvance,
        productName: productName,
      });
    }

    if ((value - advance) > 0) {
      equityRemainingGraphDataWithoutPayment.push({
        date: i,
        close: value - advance,
      });
    } else {
      if ((value - advance) < 0) {
        equityRemainingGraphDataWithoutPayment.push({
          date: i,
          close: 0,
        });
      }
    }
    if ((value - advanceWithPayment) > 0 && ((value - advanceWithPayment) < value)) {
      equityRemainingGraphDataWithPayment.push({
        date: i,
        close: (value - advanceWithPayment),
      });
    } else {
      if ((value - advanceWithPayment) < 0) {
        equityRemainingGraphDataWithPayment.push({
          date: i,
          close: 0,
        });
      }
      if ((value - advanceWithPayment) >= value) {
        equityRemainingGraphDataWithPayment.push({
          date: i,
          close: (value),
        });
      }
    }

    if (advance > 0) {
      loanBalanceGraphDataWithOutPayment.push({
        date: i,
        close: advance,
      });
    } else {
      if (advance < 0) {
        loanBalanceGraphDataWithOutPayment.push({
          date: i,
          close: 0,
        });
      }
    }
    if (advanceWithPayment > 0) {
      loanBalanceGraphDataWithPayment.push({
        date: i,
        close: advanceWithPayment,
      });
    } else {
      if (advanceWithPayment < 0) {
        loanBalanceGraphDataWithPayment.push({
          date: i,
          close: 0,
        });
      }
    }
  }

  return {
    dataRemainingBalanceTable,
    equityRemainingGraphDataWithoutPayment,
    equityRemainingGraphDataWithPayment,
    loanBalanceGraphDataWithOutPayment,
    loanBalanceGraphDataWithPayment,
  };
};
